import { LinkButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { useLanguage } from "@digipost/translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useState } from "react";
import { Link } from "react-router";

import Translated from "../infrastructure/components/Translated";
import { LanguageLinks } from "../infrastructure/hooks/translate";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import styles from "./MobileMenu.module.less";

function MobilMenu(): React.ReactElement {
  const [showLanguageMenu, setShowLanguangeMenu] = useState(false);
  const rootPath = useRootPath();
  const { language } = useLanguage();

  return (
    <div className={styles.mobileMenu}>
      <ul>
        <li>
          <a href={"/" + (language === "nb" ? "" : language)}>
            <Heading
              level={3}
              size="small"
              className={styles.mobileMenuElement}
            >
              <Translated textKey="generic.to_front_page" />
            </Heading>
          </a>
        </li>
        {location.pathname.includes("business") ? (
          <li>
            <Link to={`${rootPath}/`}>
              <Heading
                level={3}
                size="small"
                className={styles.mobileMenuElement}
              >
                <Translated textKey="login.header_to_private" />
              </Heading>
            </Link>
          </li>
        ) : (
          <li>
            <Link to={`${rootPath}/business`}>
              <Heading
                level={3}
                size="small"
                className={styles.mobileMenuElement}
              >
                <Translated textKey="login.header_to_org" />
              </Heading>
            </Link>
          </li>
        )}
        <li>
          <LinkButton
            onClick={() => setShowLanguangeMenu((prevState) => !prevState)}
            className={classNames(
              styles.languageMenuButton,
              styles.languageMenu,
            )}
          >
            <span>
              <Heading
                level={3}
                size="small"
                className={styles.mobileMenuElement}
              >
                <Translated textKey="login.header_langauge" />
              </Heading>
            </span>
            <FontAwesomeIcon
              className={styles.mobilemenuIcon}
              icon={["fas", showLanguageMenu ? "minus" : "plus"]}
            />
          </LinkButton>
        </li>
        {showLanguageMenu && (
          <LanguageLinks
            style={styles.menuLanguageLink}
            listStyle={styles.languageMenuButton}
          />
        )}
      </ul>
    </div>
  );
}

export default MobilMenu;
